/**
 * 再接続の待ち時間。
 *
 * 中国の回線環境では切断が起きる前提で作る。
 * 1, 2, 4, 8, 10, 10... 秒と伸ばし、10秒で頭打ちにする。
 * 上限を設けるのは、講義中に何分も繋がらないままにしないため。
 */

// 初回は待たずに即時再試行する。瞬断(ローミングのトンネル再確立など)は
// 1秒待つより即やり直す方が字幕の欠落が短くて済む(現地の切断報告への対策)。
export const BACKOFF_STEPS_MS = [0, 1000, 2000, 4000, 8000, 10000] as const;
export const MAX_BACKOFF_MS = 10000;

/** @param attempt 0 始まりの再試行回数。 */
export function backoffDelay(attempt: number): number {
  if (attempt < 0) return BACKOFF_STEPS_MS[0];
  return BACKOFF_STEPS_MS[Math.min(attempt, BACKOFF_STEPS_MS.length - 1)] ?? MAX_BACKOFF_MS;
}

/**
 * ゆらぎを加えた待ち時間。
 * 複数人の端末が同時に切断された場合、同じ秒数で一斉に再接続すると
 * サーバー側の同時接続上限に弾かれ合うため、±20% ずらす。
 */
export function backoffDelayWithJitter(attempt: number, random: () => number = Math.random): number {
  const base = backoffDelay(attempt);
  const jitter = base * 0.2 * (random() * 2 - 1);
  return Math.max(0, Math.round(base + jitter));
}
